import React, { useState } from "react";
import "../../../../../Assets/Styles/Checkbox.scss";

const Checkbox = (props) => {
  const [IsChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!IsChecked);
    props.ChangeEvent();
  };

  return (
    <div
      id={props.Id}
      className={
        IsChecked ? "checkbox-wrapper active-checkbox" : "checkbox-wrapper"
      }
    >
      <div className="square" onClick={() => handleClick()}>
        <i className="feather-check"></i>
      </div>
    </div>
  );
};
export default Checkbox;
